import { render, staticRenderFns } from "./UiDrawer.vue?vue&type=template&id=91449898&scoped=true"
import script from "./UiDrawer.vue?vue&type=script&lang=ts"
export * from "./UiDrawer.vue?vue&type=script&lang=ts"
import style0 from "./UiDrawer.vue?vue&type=style&index=0&id=91449898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91449898",
  null
  
)

export default component.exports